import { observer } from "mobx-react";
import { Button, Grid } from "@material-ui/core";
import {
    Card,
    CardActionArea,
    CardContent,
    Centered,
    FlexRowSpaceBetween,
    Typography,
} from "../../../../../common/components/libs";
import styles from "../style.module.css";
import { localize } from "../../../../../common/libs";
import React from "react";
import { Settings as SettingsIcon } from "react-feather";
import { useHistory } from "react-router-dom";
import { MenuWithExtraData } from "../../../../../services/menu/models";
import { useTranslation} from "react-i18next";


const MenuComponent = ({ item }: {item: MenuWithExtraData}) => {
    const {t} = useTranslation(["general", "menu"]);

    const history = useHistory();
    const navigateTo = (menuId: number) => {
        history.push(`/menus/regular/${menuId}/view`);
    };

    return (
        <Grid item xs={12} sm={6} md={4} lg={4} xl={4}>
            {/*<CheckListWithRegistrationSteps/>*/}
            <Card
                className={styles.menu}
                elevation={2}
                onClick={() => navigateTo(item.id)}
            >
                <CardContent>
                    <FlexRowSpaceBetween>
                        <Typography gutterBottom variant="h5" component="h2" mb={0}>
                            {localize(item.data.name)}
                        </Typography>
                    </FlexRowSpaceBetween>
                    <Typography mt={4} component="p">
                        {t("menu:menusList.menu.categories")} {item.menuCategoriesQuantity} {t("general:units.pieces")}
                    </Typography>
                    <Typography mt={2} mb={2} component="p">
                        {t("menu:menusList.menu.positions")} {item.menuItemsQuantity} {t("general:units.pieces")}
                    </Typography>
                </CardContent>
                <CardActionArea p={2}
                                onClick={(e: React.MouseEvent) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    // menuStore.forms.showPopupForm(MenuFormType.createMenu, item)
                                    const menuId = item.id;
                                    history.push(`/menus/regular/settings/${menuId}`);
                                }}
                >
                    <Centered>
                        <Button
                            color="primary"
                        >
                            <SettingsIcon size={15}/>
                            <span
                                style={{ display: "inline-block", minWidth: 5 }}
                            />
                            {t("menu:menusList.menu.ordersSettings")}
                        </Button>
                    </Centered>
                </CardActionArea>
            </Card>
        </Grid>
    )
};

export default observer(MenuComponent)
